import React from 'react';
import {useAtomValue} from 'jotai';
import {Navigate, Outlet} from 'react-router-dom';
import {isAuthorizedAtom} from 'features/auth/model/authAtom';

export function RequireGuest(): React.ReactElement {
	const isAuthorized = useAtomValue(isAuthorizedAtom);

	if (isAuthorized) {
		return <Navigate to="/orders" replace />;
	}

	return <Outlet />;
}

